import { Flex } from "@acko-tech/building-blocks.ui.common";
import React, { useEffect, useState } from "react";
import { CouponCardWrapper, CouponPara, CouponParaHeading } from "./styles";
import InputWidgetWithButton from "@components/inputFieldWithButton";
import { useRouter } from "next/router";
import { handleApplyDiscountAndUpdateProps } from "@actions/handleApplyDiscount";
import { BasicLoader } from "@acko-tech/building-blocks.ui.loaders";
import {
  AppliedDiscountText,
  RenoveDiscountButton
} from "@widgets/discountCard/styles";
import { connect, useSelector } from "react-redux";
import { getWidgetSpecificProp } from "@utils/index";
import { useOnload } from "@utils/useOnLoad";

interface CouponCardProps {
  discountLogo: string;
  headingText: string;
  tagText: string;
  cardHeading: string;
  couponDesc: string;
  discountSecDesc?: string;
  applyDiscountLabel?: string;
  appliedDiscountText?: string;
  showAppliedDiscountText?: boolean;
  removeDiscountBtnLabel?: string;
  appliedImgSrc?: string;
  actions?: any;
  isApplied: boolean;
  value: string;
  code: string;
  id: string;
  is_visible: boolean;
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    code: getWidgetSpecificProp(
      state.configuration?.normalisedConfig,
      ownProps.id,
      "code"
    ),
    value: getWidgetSpecificProp(
      state.configuration?.normalisedConfig,
      ownProps.id,
      "value"
    )
  };
};

const CouponCard = (props: CouponCardProps) => {
  const {
    discountLogo,
    id,
    cardHeading,
    couponDesc,
    actions,
    isApplied,
    appliedDiscountText,
    showAppliedDiscountText = true,
    removeDiscountBtnLabel,
    value,
    code,
    is_visible
  } = props;

  const [couponCode, setCouponCode] = useState(code);
  const [isLoading, setIsLoading] = useState(false);
  const [isUserApplied, setisUserApplied] = useState(isApplied);
  const [errorMessage, setErrorMessage] = useState("");
  const { on_click, on_load, on_discount_success, on_discount_failure, onApplyDiscount } = actions;
  const router = useRouter();
  const { proposal_ekey } = router.query;

  const { selectedDiscount } = useSelector(({ globalState }: any) => {
    return {
      selectedDiscount: globalState?.selectedDiscount
    };
  });

  useOnload({ on_load });


  useEffect(() => {
    if (selectedDiscount) {
      setisUserApplied(selectedDiscount === code);
    }
  }, [selectedDiscount, code]);

  const handleInputChange = (e) => {
    setErrorMessage("");
    setCouponCode(e.target.value);
  };

  const handleApplyCoupon = async () => {
    if (on_click?.length > 0) {
      on_click?.forEach((eachFunc: any) => {
        typeof eachFunc.funCall === "function" &&
          eachFunc.funCall(eachFunc.args);
      });
    }
    const res = await handleApplyDiscountAndUpdateProps(
      isUserApplied,
      setIsLoading,
      proposal_ekey,
      onApplyDiscount,
      setisUserApplied,
      couponCode,
      on_discount_success,
      on_discount_failure,
      setCouponCode,
      id
    );
    if (res) {
      setErrorMessage(res);
    }
  };
  if(!is_visible) return <></>;
  return (
    <>
      {isLoading ? <BasicLoader /> : null}
      <CouponCardWrapper errorMessage={errorMessage}>
        <Flex flexDirection="row" justifyContent="space-between">
          <img src={discountLogo} width={56} height={56} />
        </Flex>
        <CouponParaHeading>{cardHeading}</CouponParaHeading>
        {!isUserApplied && <CouponPara>{couponDesc}</CouponPara>}
        {isUserApplied ? (
          <Flex justifyContent="space-between">
            {showAppliedDiscountText && (
              <Flex>
                <AppliedDiscountText style={{ marginLeft: "0px" }}>
                  {appliedDiscountText} ₹{value}
                </AppliedDiscountText>
              </Flex>
            )}
            <RenoveDiscountButton size="medium" onClick={handleApplyCoupon}>
              {removeDiscountBtnLabel}
            </RenoveDiscountButton>
          </Flex>
        ) : (
          <div style={{ width: "max-width" }}>
            <InputWidgetWithButton
              disabled={!couponCode}
              clickHandler={handleApplyCoupon}
              placeholder="Enter coupon code"
              CTA="Apply"
              changeHandler={handleInputChange}
              error={errorMessage}
            />
          </div>
        )}
      </CouponCardWrapper>
    </>
  );
};

export default connect(mapStateToProps)(CouponCard);
